export const FontNames = [
  "Ubuntu",
  "Abril Fatface",
  "Acme",
  "Alba Matter",
  "Alfa Slab",
  "Americana",
  "Antique Olive",
  "Anton",
  "Antonio",
  "Architectural",
  "Archivo Narrow",
  "Arial",
  "Arial Bold",
  "Audiowide",
  "Avant Extra Bold",
  "Avant Garde Medium",
  "Balthazer",
  "Bauhaus",
  "Bangers",
  "Barlow Condensed",
  "Bebas",
  "Benguiat",
  "Berkshire Swash",
  "Bodoni Italic",
  "Brush Script",
  "Caprasimo",
  "Casual Italic",
  "Century Bold Condensed",
  "Century Schoolbook",
  "Clarendon Bold",
  "Clarion",
  "Clearview Light",
  "Clearview Bold",
  "Consort",
  "Consort Condensed",
  "Cookie",
  "Country Gothic",
  "Creepster",
  "Crushed",
  "Exo Bold",
  "Fjalla",
  "Fontdiner Swanky",
  "Friz Quadrata",
  "Futura",
  "Futura Bold",
  "Futura Condensed",
  "Futura Demibold",
  "Gemco",
  "Grand Hotel",
  "Helvetica",
  "Helvetica Bold",
  "Helvetica Medium Condensed",
  "Herman Italic",
  "Holtwood One",
  "Impact",
  "Italicized Script",
  "Kavoon",
  "Lato Bold",
  "Leckerli One",
  "Lily Script One",
  "Limelight",
  "Lobster",
  "Luckiest Guy",
  "Magneto",
  "Mystery Quest",
  "Nerko One",
  "Norwester",
  "Nova Square",
  "Oleo Script Bold",
  "Optima",
  "Optima Semibold",
  "Oswald",
  "Pacifico",
  "Palatino",
  "Palatino Semibold",
  "Peralta",
  "Perfaire",
  "Permanent Marker",
  "Ranchers",
  "Roboto Slab",
  "Rubik",
  "Saira Stencil",
  "Salsa",
  "Sarina",
  "Satisfy",
  "Shojumaru",
  "Short Stack",
  "Sofia",
  "Standard Block",
  "Standard Block Condensed",
  "Times Roman",
  "Titillium Web",
  "Custom Font File",
];
